import { Component, Inject, OnInit } from "@angular/core";
import { FormControl, Validators } from "@angular/forms";
import {
    MAT_DIALOG_DATA,
    MatDialog,
    MatDialogRef,
} from "@angular/material/dialog";
import { PageOptions } from "app/main/interface/pageOptions";
import { ScheduleService } from "app/main/schedule/schedule.service";
import { SnackBarService } from "app/services/snackbar.service";
import { UnregisteredScheduleComponent } from "../unregistered-schedule.component";
import { debounceTime, distinctUntilChanged, Subject, takeUntil } from "rxjs";

@Component({
    selector: "app-select-procedure",
    templateUrl: "./select-procedure.component.html",
    styleUrls: ["./select-procedure.component.scss"],
})
export class SelectProcedureComponent implements OnInit {
    procedureControl = new FormControl("", Validators.required);
    procedureList = [];
    procedurePageOptions: PageOptions;
    private _unsubscribeAll: Subject<any>;

    constructor(
        @Inject(MAT_DIALOG_DATA) public data: any,
        public dialogRef: MatDialogRef<SelectProcedureComponent>,
        private readonly scheduleService: ScheduleService,
        private snackBar: SnackBarService,
        public _matDialog: MatDialog
    ) {
        this.procedurePageOptions = new PageOptions();
        this._unsubscribeAll = new Subject();
    }
    ngAfterViewInit() {}

    async ngOnInit() {
        console.log("🚀 ~ SelectProcedureComponent ~ ngOnInit ~ this.data:", this.data)
        this.getProcedureList();
        this.filterProcedure();
    }

    displayFn(procedure?: any): string | undefined {
        if (!procedure) {
            return null;
        }
        if (typeof procedure === "string") {
            return procedure;
        }
        return procedure.name;
    }

    getProcedureList() {
        const insuranceId = this.data.insuranceId;
        const performerId = this.data.performerId;
        const companyId = this.data.companyId;

        if (insuranceId && performerId && companyId) {
            this.scheduleService
                .getProcedurePageSimpleList(
                    this.procedurePageOptions,
                    insuranceId,
                    performerId,
                    companyId
                )
                .then((res) => {
                    this.procedureList = res.body.content;
                })
                .catch((err) =>
                    console.error("Erro ao buscar procedimentos:", err)
                );
        } else {
            this.procedureList = [];
        }
    }

    filterProcedure() {
        this.procedureControl.valueChanges
            .pipe(
                takeUntil(this._unsubscribeAll),
                debounceTime(500),
                distinctUntilChanged()
            )
            .subscribe((res) => {
                let filter = "";
                if (res && res.name) {
                    this.procedurePageOptions.argument = res.name;
                }
                if (typeof res === "string") {
                    filter = res;
                }
                this.procedurePageOptions.argument = filter;
                this.getProcedureList();
            });
    }

    confirm() {
        const selectedProcedure = this.procedureControl.value;
        if (selectedProcedure?.id) {
            this.dialogRef.close(selectedProcedure); // ✅ Retorna o valor para o chamador
        }
    }
}
